const resources = {
    linkLead: 'Highly rated by customers for:'
};

export default function getResource(label) {
    return resources[label];
}

